<template>
  <div class="app-container" style="background:#f9f9f9">
    <!-- 工具栏 -->
    <div class="filter-container">
      <!-- <div class="filter-data all">
                <div class="label filter-item">发起人角色：</div>
                <el-radio-group class="filter-item" size="mini" v-model="createUser">
                    <el-radio-button v-for="(item,index) in createUserOptions" :key="index" :label="item"></el-radio-button>
                </el-radio-group>
            </div> -->
      <div class="filter-data" style="margin-right: 15px">
        <div class="label filter-item">用途：</div>

        <el-cascader filterable size="small" style="width:220px" ref="useSelect" class="filter-item" placeholder="请选择" v-model="useList" :options="useOptions" :props="{ expandTrigger: 'hover',label:'name',value:'id',children:'child' }" @change="handleUse"></el-cascader>
      </div>
      <!-- <div class="filter-data" style="margin-right: 15px">
        <div class="label filter-item">热搜：</div>
        <el-radio-group class="filter-item" size="mini" v-model="heatValue" @change="handeleHeat">
          <el-radio-button v-for="(item,index) in heatOptions" :key="index" :label="item.id">{{item.name}}</el-radio-button>
        </el-radio-group>
      </div> -->
    </div>

    <!-- 任务设定 -->
    <el-collapse class="collapse" v-model="activeId" v-loading="formLoading">
      <el-collapse-item v-for="(collapseItem,collapseIndex) in applyList" :key="collapseIndex" :name="collapseIndex">
        <template slot="title">
          <span>{{collapseItem.title}}</span>
          <!-- <el-button class="rightButn" size="mini" type="primary">常规任务设定</el-button> -->
        </template>
        <!-- 表单 -->
        <el-form :model="collapseItem.ruleForm" :ref="'ruleForm-'+collapseIndex" label-width="180px" class="demo-ruleForm">

          <template v-for="(item,index) in collapseItem.ruleForm.typelist">

            <el-form-item v-if="!item.iftable" :key="index" :label="item.name+'：'" :prop="item.required ? `typelist.${index}.fieldValue` : null" :rules="item.required ? (item.id == 4 || item.id == 20 ? [{ required: true, message:`${item.name}不能为空`, trigger: ['change','blur']},{min:1, max:16, message: `长度在 1 到 ${item.maxlength} 个字符`, trigger: ['blur','change']}] : { required: true, message:`${item.name}不能为空`, trigger: ['change','blur']}) : null">

              <!-- 时间 -->
              <el-date-picker v-if="item.type == 'date'" size="small" v-model="item.fieldValue" type="datetime" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="min-width:18vw"></el-date-picker>

              <!-- 下拉选择 -->
              <template v-if="item.type == 'select'">
                <el-select v-if="item.id == 2" size="small" v-model="item.fieldValue" filterable clearable :placeholder="'请选择'+item.name" style="min-width:18vw">
                  <el-option v-for="(selectItem,selectIndex) in projectOptions" :key="selectIndex" :label="selectItem.name" :value="selectItem.id"></el-option>
                </el-select>

                <el-select v-else-if="item.id == 56" size="small" v-model="item.fieldValue" filterable clearable :placeholder="'请选择'+item.name" style="min-width:18vw">
                  <el-option v-for="(selectItem,selectIndex) in typeOptions" :key="selectIndex" :label="selectItem.name" :value="selectItem.id"></el-option>
                </el-select>

                <el-select v-else size="small" v-model="item.fieldValue" filterable clearable :placeholder="'请选择'+item.name" style="min-width:18vw">
                  <el-option v-for="(selectItem,selectIndex) in item.valuelist" :key="selectIndex" :label="selectItem" :value="selectItem"></el-option>
                </el-select>
              </template>

              <!-- 级联选择 -->
              <el-cascader v-if="item.type == 'multiple_cascader'" size="small" v-model="item.fieldValue" :options="tagOptions" :props="props" filterable clearable collapse-tags placeholder="请选择标签" style="min-width:18vw"></el-cascader>

              <el-input v-if="item.type == 'input'" size="small" v-model="item.fieldValue" :placeholder="'请输入'+item.name" clearable style="min-width:18vw; width:auto; max-width:23vw"></el-input>

              <el-input class="numberInput" v-if="item.type == 'number'" type="number" min="0" size="mini" v-model="item.fieldValue" :placeholder="'请输入'+item.name" style="min-width:18vw; width:auto; max-width:23vw">
              </el-input>

              <!-- switch 开关 -->
              <el-switch v-if="item.type == 'switch'" v-model="item.fieldValue" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"></el-switch>

              <!-- 上传 -->
              <simple-uploader :class="item.minlength > 0 || item.maxlength > 0 ? 'upload-demo-all' : ''" v-if="item.type == 'upload'" ref="uploader" source="createApply" :id="String(item.id)" :minNum="item.minlength" :maxNum="item.maxlength?item.maxlength:20" @onSuccess="(file, fileList) => handleSuccess(file, fileList, item, collapseIndex, index)" @onRemove="(fileList) => handleRemove(fileList, item)" style="min-width:400px; width:30vw">
              </simple-uploader>

              <!-- <el-upload class="upload-demo" :class="item.minlength > 0 || item.maxlength > 0 ? 'upload-demo-all' : ''" v-if="item.type == 'upload'"
                                :action= "updateUrl"
                                :multiple="true"
                                :show-file-list="true"
                                :limit="item.maxlength"
                                :file-list="item.fieldValue"
                                :on-remove="(file, fileList) => handleRemove(file, fileList, item)"
                                :on-error="handleError"
                                :on-exceed="() => handleExceed(item)"
                                :on-success="(response,file,fileList) => handleSuccess(response,file,fileList,item, collapseIndex, index)"
                            >
                                <el-button size="mini" type="primary">点击上传</el-button>
                                <div v-if="item.minlength > 0 || item.maxlength > 0" slot="tip" class="el-upload__tip" >最少上传{{item.minlength}}个文件，最多上传{{item.maxlength}}个文件</div>
                            </el-upload> -->

              <!-- 富文本 -->
              <markdown-editor v-if="item.type == 'textarea'" v-model="item.fieldValue" mode="wysiwyg" language="zh-CN" height="40vh" @input="handleDescribe($event, collapseIndex, index)" style="width:65vw;margin-bottom:3px" />

              <!-- 规格 -->
              <div v-if="item.type == 'inputTable'" class="addTable">
                <el-form :model="item.speForm" :ref="'ruleForm-'+collapseIndex + 'speForm'" class="speForm">
                  <el-form-item class="spe-item" v-for="(speItem,speIndex) in item.speForm.speList" :key="speIndex" :label="speItem.name+'：'" :prop="speItem.required ? `speList.${speIndex}.fieldValue` : null" :rules="speItem.required ? (speItem.id == 4 || speItem.id == 20 ? [{ required: true, message:`${speItem.name}不能为空`, trigger: ['change','blur']},{min:1, max:16, message: `长度在 ${speItem.minlength} 到 ${speItem.maxlength} 个字符`, trigger: 'blur'}] : { required: true, message:`${speItem.name}不能为空`, trigger: ['change','blur']}) : null">

                    <el-input v-if="speItem.type == 'input'" size="mini" v-model="speItem.fieldValue" :placeholder="'请输入'+speItem.name" clearable style="width:130px"></el-input>

                    <el-input v-if="speItem.type == 'inputTextarea'" type="textarea" :rows="2" :placeholder="'请输入'+speItem.name" v-model="speItem.fieldValue"> </el-input>

                    <el-input class="numberInput" v-if="speItem.type == 'number'" type="number" min="0" size="mini" v-model="speItem.fieldValue" :placeholder="'请输入'+speItem.name" style="width:130px;"></el-input>

                    <el-select v-if="speItem.type == 'select'" size="mini" v-model="speItem.fieldValue" filterable clearable :placeholder="'请选择'+item.name" style="width:130px">
                      <el-option v-for="(selectItem,selectIndex) in speItem.valuelist" :key="selectIndex" :label="selectItem" :value="selectItem"></el-option>
                    </el-select>

                  </el-form-item>
                </el-form>

                <el-button type="primary" size="mini" @click="handleAddSpe(item, collapseIndex, index)">添加</el-button>

                <el-table class="grayTableTile" size="small" :data="item.fieldValue" border style="width:60vw;">
                  <el-table-column v-for="(headItem,headIndex) in item.speForm.speHeader" :key="headIndex" :prop="headItem.property" :label="headItem.label" min-width="100">
                    <template slot-scope="scope">
                      <span v-if="!scope.row.edit">{{scope.row[headItem.property]}}</span>
                      <template v-else>
                        <el-form :model="scope.row" :ref="'tableForm-'+scope.$index">
                          <el-form-item :prop="headItem.required ? `${headItem.property}` : null" :rules="headItem.required ? { required: true, message:`${headItem.label}不能为空`, trigger: ['change','blur']} : null">
                            <el-input v-if="headItem.type == 'input' || headItem.type == 'number' || headItem.type == 'inputTextarea'" v-model="scope.row[headItem.property]" :type="headItem.type == 'input'?'text':headItem.type == 'number'?'number':'textarea'" clearable size="mini"></el-input>
                            <el-select v-if="headItem.type == 'select'" v-model="scope.row[headItem.property]" filterable clearable size="mini">
                              <el-option v-for="(selectItem,selectIndex) in headItem.valuelist" :key="selectIndex" :label="selectItem" :value="selectItem"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                      <template v-if="!scope.row.edit">
                        <i class="edit-icon el-icon-edit" @click="handleEdit(scope.row)"></i>
                        <i class="delete-icon el-icon-delete" @click="handleDelete(scope.row, item, scope.$index)"></i>
                      </template>
                      <template v-else>
                        <i class="check-icon el-icon-check" @click="handleSave(scope.row,scope.$index)"></i>
                        <i class="delete-icon el-icon-close" @click="handleCancel(scope.row, scope.$index)"></i>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 尺寸 -->
              <el-table v-if="item.type == 'sizeList'" class="grayTableTile" size="small" :data="channelList" border height="400" @selection-change="handleSizeSelection($event,item)" style="width:65vw; margin-bottom:3px">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="尺寸" min-width="120">
                  <template slot-scope="scope">{{scope.row.width}} * {{scope.row.height}}</template>
                </el-table-column>
                <el-table-column label="大小" prop="picsize" min-width="100"></el-table-column>
                <el-table-column label="类型" prop="pictype" min-width="100"></el-table-column>
                <el-table-column label="说明" prop="picdesc" min-width="280"></el-table-column>
              </el-table>

              <!-- 渠道 -->
              <div v-if="item.type == 'channelList'">
                <el-select size="small" v-model="item.selectValue" multiple filterable clearable :placeholder="'请选择'+item.name" style="min-width:18vw" @change="handleChannel($event,collapseIndex)">
                  <el-option v-for="(selectItem,selectIndex) in channelGroups" :key="selectIndex" :label="selectItem.channelname" :value="selectItem.channelname"></el-option>
                </el-select>
                <el-table :ref="'multipleChannelTable-'+collapseIndex" class="grayTableTile" size="small" :data="channelList" border height="400" @selection-change="handleChannelSelection($event,item)" style="width:65vw;margin-top:10px;margin-bottom:3px">
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column label="渠道" prop="channelname" min-width="100"></el-table-column>
                  <el-table-column label="应用场景" prop="channelname" min-width="100"></el-table-column>
                  <el-table-column label="尺寸" min-width="110">
                    <template slot-scope="scope">{{scope.row.width}} * {{scope.row.height}}</template>
                  </el-table-column>
                  <el-table-column label="大小" prop="picnum" min-width="100"></el-table-column>
                  <el-table-column label="类型" prop="pictype" min-width="100"></el-table-column>
                  <el-table-column label="说明" prop="picdesc" min-width="280"></el-table-column>
                </el-table>
              </div>

              <!-- 提示 -->
              <el-popover v-if="item.desc" popper-class="gray-popper" placement="right" width="500" trigger="hover" :content="item.desc">
                <i class="el-icon-question" slot="reference" style="cursor: pointer;" />
              </el-popover>

            </el-form-item>
          </template>
        </el-form>
      </el-collapse-item>
    </el-collapse>

    <!-- 添加 -->
    <div class="addButn">
      <el-button size="mini" type="success" icon="el-icon-plus" @click="handleContinueAdd">继续添加</el-button>
      <el-button size="mini" type="danger" icon="el-icon-minus" @click="handleDeleteUp" v-if="applyList.length > 1">删除上一行</el-button>
    </div>

    <!-- 提交 -->
    <div class="footer-box">
      <el-button class="butn" type="primary" :loading="submitLoading" @click="handleSubmit">提 交</el-button>
      <div class="message-box">
        <span class="label">通知方式：</span>
        <el-checkbox v-model="sendMail" :true-label="1" :false-label="0">邮箱</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import SimpleUploader from '../materialCenter/components/simpleUploader.vue'
import { taskFieldList_ajax, taskListTree_ajax, projectList_ajax, taskTypeList_ajax, artFlowChoiceLabel_ajax, addArtFlow_ajax, artChannelName_ajax, artChannelList_ajax, saveUploadFlowFile_ajax } from '@File~/api/file'

export default {
  components: { MarkdownEditor, SimpleUploader },
  data() {
    return {
      createUser: '宣发',
      createUserOptions: ['宣发', '美术', '行政', '总办', '三方'],

      useList: [],
      use: '',
      useOptions: [],

      heatValue: '',
      heatOptions: [
        {
          id: '1,20',
          name: '平面/渠道特殊资源'
        },
        {
          id: '1,9',
          name: '平面/渠道批量'
        },
        {
          id: '1,24',
          name: '平面/商店图设计'
        },
        {
          id: '1,44',
          name: '平面/英雄游戏'
        },
      ],

      formLoading: true,

      // 时间
      pickerOptions: {
        // 当前日期之前的日期不可选
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      taskFieldList: [], // 接口返回的任务字段列表
      applyList: [
        {
          title: '',
          ruleForm: {
            typelist: []
          },
        }
      ],

      activeId: 0,

      projectOptions: [], // 项目列表
      typeOptions: [], // 任务分类

      // 标签
      tagOptions: [],
      props: {
        multiple: true,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        children: 'labelList'
      },

      // 渠道数据
      channelGroups: [],
      channelList: [],

      // 上传
      updateUrl: this.$store.getters.uploadUrl, // 上传文件地址

      // 提交按钮loading
      submitLoading: false,
      // 是否发送邮件
      sendMail: 0, // 0否 1是

    }
  },

  created() {
    this.getUseList() // 获取用途列表
    this.getLabels() // 获取标签列表
    this.getProject() // 获取项目列表
  },

  methods: {
    // 获取用途列表
    getUseList() {
      taskListTree_ajax().then(response => {
        if (response.code == 1) {
          this.useOptions = response.data
          this.useList = [response.data[0].id, response.data[0].child[0].id]
          this.use = response.data[0].child[0].id

          this.getChannelName() // 获取渠道名
          this.getChannelList() // 获取渠道列表
          this.getTaskList(this.use) // 获取任务字段列表
        }
      })
    },

    // 项目列表
    getProject() {
      projectList_ajax().then(response => {
        if (response.code == 1) {
          this.projectOptions = response.data
        }
      })
    },
    // 项目分类
    getTaskType() {
      taskTypeList_ajax({ taskIds: [this.use] }).then(response => {
        if (response.code == 1) {
          this.typeOptions = response.data
        }
      })
    },

    // 获取标签列表
    getLabels() {
      artFlowChoiceLabel_ajax().then(response => {
        if (response.code == 1) {
          this.tagOptions = response.data
        }
      })
    },

    // 获取渠道名
    getChannelName() {
      // 1:渠道常规设定;2:渠道商店图设定;3:投放常规设定
      if (this.use == 6) {
        const type = 1
        artChannelName_ajax(type).then(response => {
          this.channelGroups = response.data
        })
      }
    },

    // 获取渠道列表
    getChannelList() {
      if (this.use == 6 || this.use == 9) {
        const type = this.use == 6 ? 1 : this.use == 9 ? 2 : null
        artChannelList_ajax(type).then(response => {
          this.channelList = response.data
        })
      }
    },

    // 获取任务字段列表
    getTaskList(val) {
      this.formLoading = true
      taskFieldList_ajax(val).then(response => {
        this.formLoading = false
        if (response.code == 1) {
          var taskTypes = [{
            desc: "",
            fieldValue: null,
            id: 56,
            iftable: false,
            iftableInt: 0,
            maxlength: null,
            minlength: null,
            name: "任务分类",
            required: true,
            requiredInt: 1,
            type: "select",
            valuelist: null,
            valuelistStr: "",
          }]

          this.taskFieldList = taskTypes.concat(response.data)

          //   this.taskFieldList = response.data

          this.applyList = [
            {
              title: this.$refs['useSelect']._data.presentText,
              ruleForm: {
                typelist: []
              },
            }
          ]

          this.initTaskList() // 初始化任务字段列表

          // console.log('=====',this.applyList)

          this.getTaskType()//项目分类列表
        }
      })
    },

    // 初始化任务字段列表
    initTaskList() {
      const list = JSON.parse(JSON.stringify(this.taskFieldList))
      const speList = []
      const speHeader = []
      this.applyList[this.applyList.length - 1].ruleForm.typelist = list.map(v => {
        if (v.type == 'upload' || v.type == 'channelList' || v.type == 'inputTable' || v.type == 'multiple_cascader' || v.type == 'sizeList') {
          v.fieldValue = []
        } else if (v.type == 'switch') {
          v.fieldValue = 1
        } else {
          v.fieldValue = ''
        }

        if (v.iftable) {
          speList.push(v)
          speHeader.push({
            label: v.name,
            property: v.name,
            type: v.type,
            valuelist: v.valuelist,
            required: v.required
          })
        }

        if (v.type == 'inputTable') {
          this.$set(v, 'speForm', { speList: speList, speHeader: speHeader })
        }

        return v
      })

      this.applyList.forEach((item, index) => {
        this.$nextTick(() => {
          const ruleForm = 'ruleForm-' + index
          // console.log(this.$refs[ruleForm][0])
          this.$refs[ruleForm][0].clearValidate()
        })
      })
    },

    // 最终提交
    handleSubmit() {
      let resultData = []
      let pass = true
      let isValid = true
      this.applyList.forEach((item, index) => {
        const ruleForm = 'ruleForm-' + index
        // console.log('=======',ruleForm)
        this.$refs[ruleForm][0].validate((valid) => {
          if (valid) {
            try {
              item.ruleForm.typelist.forEach(list => {
                // 上传图
                if (list.type == 'upload' && list.required) {
                  if (list.fieldValue.length < list.minlength) {
                    this.$message({
                      type: 'error',
                      message: '第' + parseInt(index + 1) + '个 [' + item.title + ']申请,最少上传' + list.minlength + '个 “' + list.name + '” 文件'
                    });

                    isValid = false
                    throw Error();
                  }
                }

                // console.log('继续====')

                // 规格
                if (list.type == 'inputTable') {
                  list.fieldValue.forEach(m => {
                    if (m.edit) {
                      this.$message({
                        type: 'error',
                        message: '请先保存规格数据'
                      });
                      isValid = false
                      throw Error();
                    }
                  })
                }
              })
            } catch (e) { }

            // console.log('1111111111===',isValid)
            if (isValid) {
              const data = {
                taskId: this.use,
                taskTypeId: this.use,
                userId: this.$store.getters.userId,
                roleIds: this.$store.getters.roles,
                sendMail: this.sendMail,
                artFieldList: JSON.parse(JSON.stringify(item.ruleForm.typelist))
              }
              data.artFieldList.forEach(field => {
                if (field.id == 56) {
                  data.taskTypeId = field.fieldValue
                } else if (field.id == 53) { // 选择标签

                  if (field.fieldValue.length > 0) {
                    const data = JSON.parse(JSON.stringify(field.fieldValue))
                    let listValue = []
                    data.forEach(m => {
                      listValue.push(m[1])
                    })

                    field.fieldValue = listValue.toString()
                  } else {
                    field.fieldValue = ''
                  }
                } else if (field.type == 'upload') { // 上传文件
                  if (field.fieldValue.length > 0) {
                    const data = JSON.parse(JSON.stringify(field.fieldValue))
                    let listValue = []
                    data.forEach(m => {
                      // listValue.push(m.response.data)
                      listValue.push(m.fileId)
                    })

                    field.fieldValue = listValue.toString()

                  } else {
                    field.fieldValue = ''
                  }

                } else if (field.id == 8 || field.id == 11) { // 渠道选择
                  if (field.fieldValue.length > 0) {
                    const data = JSON.parse(JSON.stringify(field.fieldValue))
                    let listValue = []
                    data.forEach(m => {
                      listValue.push(m.id)
                    })
                    field.fieldValue = listValue.toString()
                    this.$delete(field, 'selectValue')
                  } else {
                    field.fieldValue = ''
                  }
                } else if (field.type == 'inputTable') { // 规格
                  field.fieldValue.forEach(m => {
                    this.$delete(m, 'edit')
                  })
                  field.fieldValue = JSON.stringify(field.fieldValue)
                }

                if (field.iftable) {
                  this.$delete(field)
                }
              })
              resultData.push(data)
            }

            return isValid
          } else {
            pass = false
          }
        })
      })

      if (pass && isValid) {
        this.submitLoading = true
        // console.log('最终提交数据====：',resultData)
        addArtFlow_ajax(resultData).then(response => {
          this.submitLoading = false
          if (response.code == 1) {
            this.$router.push({ path: '/taskCenter/myCreate' }) // 跳转我提交的任务
          }
        })
      }
    },

    // 监听渠道组选择变化
    handleChannel(val, collapseIndex) {
      // console.log('val',val)
      const speForm = 'multipleChannelTable-' + collapseIndex
      // console.log(speForm)
      this.$refs[speForm][0].clearSelection();
      val.forEach(channel => {
        this.channelList.forEach(item => {
          if (item.channelname == channel) {
            // selections.push(item);
            this.$refs[speForm][0].toggleRowSelection(item, true)
          }
        })
      })
    },

    // 监听选中的渠道
    handleChannelSelection(val, item) {
      // console.log('table选中：',val)
      item.fieldValue = val
    },

    // 监听选中的尺寸
    handleSizeSelection(val, item) {
      item.fieldValue = val
    },

    // 继续添加
    handleContinueAdd() {
      // console.log('列表====1111',this.applyList)
      const data = {
        title: this.$refs['useSelect'].$data.selectedLabel,
        ruleForm: {
          typelist: []
        }
      }

      this.applyList.push(data)

      // console.log('列表====',this.applyList)

      this.initTaskList() // 初始化任务字段列表

      this.activeId = this.applyList.length - 1
    },

    // 删除上一行
    handleDeleteUp() {
      this.applyList.splice(this.applyList.length - 1, 1)
      this.activeId = this.applyList.length - 1
    },

    // 添加规格
    handleAddSpe(item, collapseIndex, index) {
      // console.log(item.speForm.speList)
      const speForm = 'ruleForm-' + collapseIndex + 'speForm'

      this.$refs[speForm][0].validate((valid) => {
        if (valid) {
          var obj = { edit: false }
          item.speForm.speList.map(m => {
            this.$set(obj, m.name, m.fieldValue);
          })
          item.fieldValue.push(obj)
          console.log(item.fieldValue)
        }
      })

      this.$nextTick(() => {
        const ruleForm = 'ruleForm-' + collapseIndex
        this.$refs[ruleForm][0].validateField(`typelist.${index}.fieldValue`)
      })
    },

    // 编辑已添加的规格
    handleEdit(row) {
      row.edit = true
      console.log(row)
    },

    // 删除添加的规格
    handleDelete(row, item, index) {
      item.fieldValue.splice(index, 1)
    },

    // 保存修改的规格
    handleSave(row, index) {
      const tableForm = 'tableForm-' + index
      let pass = true // 通过标识
      this.$refs[tableForm].forEach(item => { // 验证
        item.validate((valid) => {
          if (!valid) {
            pass = false
          }
        })
      })

      if (pass) { // 验证通过执行内容
        row.edit = false
      }
    },

    // 取消修改规格
    handleCancel(row, index) {
      row.edit = false
      const tableForm = 'tableForm-' + index
      this.$refs[tableForm].forEach(item => { // 验证
        item.resetFields()
      })
    },

    // 操作用途
    handleUse(val) {
      this.useList = val
      this.use = this.useList[1]
      this.heatValue = ''
      this.getChannelName() // 获取渠道名
      this.getChannelList() // 获取渠道列表

      this.applyList = []
      this.$nextTick(() => {
        this.getTaskList(this.use) // 获取任务字段列表
      })
    },

    // 操作热词
    handeleHeat(val) {
      var arr = val.split(",")
      this.useList = [parseInt(arr[0]), parseInt(arr[1])]
      this.use = this.useList[1]
      this.getChannelName() // 获取渠道名
      this.getChannelList() // 获取渠道列表

      this.$refs.useSelect.computePresentText()

      this.applyList = []
      this.$nextTick(() => {
        this.getTaskList(this.use) // 获取任务字段列表
      })
    },

    // 监听富文本框
    handleDescribe(val, collapseIndex, index) {
      if (val) {
        this.$nextTick(() => {
          const ruleForm = 'ruleForm-' + collapseIndex
          this.$refs[ruleForm][0].validateField(`typelist.${index}.fieldValue`)
        })
      }
    },

    // 上传成功
    handleSuccess(file, fileList, item, collapseIndex, index) {
      console.log('上传成功列表====', fileList)
      // 工单文件上传
      const data = {
        fileIds: [file],
        userId: this.$store.getters.userId
      }
      saveUploadFlowFile_ajax(data).then(response => {
        if (response.code == 1) {
          // field.fieldValue = response.data
          item.fieldValue = fileList

          if (fileList.length > 0) {
            const ruleForm = 'ruleForm-' + collapseIndex
            this.$refs[ruleForm][0].validateField(`typelist.${index}.fieldValue`)
          }
        }
      })
    },

    // 上传成功后删除
    handleRemove(fileList, item) {
      console.log('删除后===上传成功列表====', fileList)
      item.fieldValue = fileList
    },

    // element 上传
    // 上传成功
    // handleSuccess(response,file,fileList,item, collapseIndex, index) {
    //     console.log('上传成功====',fileList)

    //     // 工单文件上传
    //     const data = {
    //         fileIds:[response.data],
    //         userId:this.$store.getters.userId
    //     }
    //     saveUploadFlowFile_ajax(data).then(response => {
    //         if(response.code == 1) {
    //             // field.fieldValue = response.data
    //             item.fieldValue = fileList


    //             if(fileList.length > 0) {
    //                 const ruleForm = 'ruleForm-' + collapseIndex
    //                 this.$refs[ruleForm][0].validateField(`typelist.${index}.fieldValue`)
    //             }
    //         }
    //     })
    // },

    // // 删除文件
    // handleRemove(file , fileList, item) {

    //     item.fieldValue = fileList
    //     console.log('删除上传文件====', item.fieldValue)
    // },

    // // 本地上传失败
    // handleError(err) {
    //     this.$message({
    //     message: '上传失败',
    //     type: 'error'
    //     })
    // },

    // // 超出上传数量限制
    // handleExceed(item) {
    //     this.$message.warning('最多只能上传'+ item.maxlength +'个文件')
    // }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  .filter-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
  }
  .all {
    width: 100%;
  }
  .label {
    font-size: 15px;
    margin-right: 3px;
    color: #7b7b7b;
  }

  ::v-deep .el-radio-button {
    margin-right: 5px;
  }
  ::v-deep .el-radio-button__inner {
    box-shadow: -1px 0 0 0 transparent;
    border: 1px solid #dcdfe6;
    border-radius: 0;
  }
}
.collapse {
  ::v-deep .el-collapse-item__header {
    position: relative;
    padding: 0 10px;
    background: #eff2f5;
    height: 34px;
    line-height: 34px;
    .rightButn {
      position: absolute;
      right: 60px;
    }
  }
  ::v-deep .el-collapse-item__content {
    padding: 20px 0;
    min-height: 20vh;
  }

  ::v-deep .el-cascader__search-input {
    min-width: 10%;
    margin-left: 5px;
  }
}

.demo-ruleForm {
  // display: flex;
  // flex-flow: row wrap;

  ::v-deep .el-form-item {
    margin-bottom: 15px;
  }
  ::v-deep .el-form-item__error {
    padding-top: 0;
  }
  .all {
    width: 100%;
  }
  // .common{
  //     display: flex;
  //     margin-right: 10px;
  //     ::v-deep .el-form-item__content{
  //         margin-left: 0 !important;
  //     }
  // }
  .upload-demo {
    width: 20vw;
    .el-upload__tip {
      margin-top: 0;
      font-size: 10px;
      line-height: 16px;
      color: #606266;
      // color: #F56C6C;
      width: 100%;
    }
  }

  .speForm {
    display: flex;
    flex-flow: row wrap;
    .spe-item {
      display: flex;
      margin-right: 15px;
    }
  }
  .edit-icon,
  .delete-icon,
  .check-icon {
    font-size: 16px;
    cursor: pointer;
    margin: 0 8px;
  }
  .edit-icon {
    color: #409eff;
  }
  .delete-icon {
    color: #f56c6c;
  }
  .check-icon {
    color: #67c23a;
  }
}
.addButn {
  margin: 20px 0;
  // text-align: center;
}
.numberInput ::v-deep .el-input__inner {
  padding-right: 0;
}
.footer-box {
  margin: 20px auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  .butn {
    padding: 12px 20px;
  }
  .message-box {
    margin-left: 100px;
    .label {
      font-size: 15px;
      color: #7b7b7b;
    }
    ::v-deep .el-checkbox {
      color: #7b7b7b;
    }
  }
}
</style>
